module.exports = __webpack_public_path__ + "static/assets/f8eceee057087ff3b503b5ba964a1f4b.png";